
// material
import {
    Card, 
    CardContent,
    Typography,
    Stack,
    Tooltip,
    Button,
    Box,
    List,
    ListItem,
    ListItemText,
    ListSubheader,
    Switch,
    Checkbox,
    ListItemIcon,
    IconButton,
    ListItemButton
} from '@mui/material';

import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const dicas = [
    "Não levantar Pesos",
    "Fazer exercícios ao deitar",
    "Comer fruta",
]
export default function DicasUtente() {
   //const theme = useTheme();

   return (
       <Card>
        <Stack direction = "row" alignItems="center"  sx={{paddingLeft: 2, paddingTop:2}} m={1}>
            <Typography variant="h4">Recomendações para o Utente</Typography>
            <Box sx={{paddingLeft: 2}}>
                <Tooltip title="Adicionar Recomendações">
                    <Button variant="outlined" endIcon={<AddIcon fontSize="inherit" />} aria-label="add" size="medium" >
                        Adicionar
                    </Button>
                </Tooltip>
            </Box>
        </Stack>
       
       <CardContent>
            <List dense sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                {dicas.map((value, index) => {
                    
                    return (
                        <ListItem key={index} disablePadding>
                            <ListItemButton>
                                <ListItemText id={index}>
                                    <Typography variant='body1'>{value}</Typography>
                                </ListItemText>
                            

                            <ListItemIcon>
                                <Tooltip color='primary' title="Editar">
                                    <IconButton size="small">
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                            </ListItemIcon>
                            
                            <ListItemIcon>
                                <Tooltip color='primary' title="Apagar">
                                    <IconButton size="small">
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </ListItemIcon>
                            </ListItemButton>
                        </ListItem>
                    );
                })}
            </List>

       </CardContent>
       </Card>
   );
}


